<app-modal
  #reorderModal
  [modalConfig]="{
    titleText: 'Reorder sections',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'reorder-sections-modal',
    customFooter: true,
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="reorderModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <p class="text-muted small mb-2">
    Conditional sections cannot be placed first.
  </p>

  <div cdkDropList class="reorder-list" (cdkDropListDropped)="drop($event)">
    <div *ngFor="let section of sections" cdkDrag class="reorder-item">
      <div class="drag-handle" cdkDragHandle>
        <i class="bi bi-grip-vertical"></i>
      </div>
      <span class="section-name">{{
        section.title || "Untitled Section"
      }}</span>
      <i
        *ngIf="section.is_conditional"
        class="bi bi-diagram-2-fill ms-3 text-secondary"></i>
    </div>
  </div>

  <div footerContent class="d-flex justify-content-between w-100">
    <button type="button" class="btn" (click)="reorderModal.close()">
      Close
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="isSaving"
      (click)="save()">
      <span
        *ngIf="isSaving"
        class="spinner-border spinner-border-sm me-1"
        role="status"></span>
      Save
    </button>
  </div>
</app-modal>
